import React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { isInternalURL } from '@plone/volto/helpers';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Segment, Card, Header, Grid, Label, Container } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { UniversalLink, Image } from '@plone/volto/components';
import { getVocabulary } from '@plone/volto/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { keys, isEmpty, map, filter } from 'lodash';
import { formatDate } from '../../../helpers'

import { Sharing } from '../../';
import defaultImage from '../../Footer/img/logo-proursa-blanc.svg';

const PromosListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {

	let href = (linkHref?.[0]?.['@id']) || '';
	let link = href ? flattenToAppURL(href) : '';


	const vocabularySubjects = 'plone.app.vocabularies.Keywords';
	const dispatch = useDispatch();	

	useEffect(() => {
		dispatch(getVocabulary({ vocabNameOrURL: vocabularySubjects }));
	}, [dispatch]);

	return (
		<div className='promosListing'>
			<Container>
				{blockTitle && <h3 className="  my-0">{blockTitle}</h3>}
				<Grid>
					<Grid.Row  columns={12} className='pt-0'>
						{items.map((item) => (
							<Grid.Column className="mb-4 " 
								mobile={12} tablet={12} computer={6}
								key={item['@id']} >
								<Card fluid as="article" className={"newsItem position-relative newsItem--promos" + (item?.image_field ? ' newsItem-hasImage' : ' newsItem--noImage')} >
									<figure className='newsItem__figure position-relative m-0'>
										<div className='overflow-hidden  newsItem__figure__wrapper'>
											{item.image_field ? (
												<Image
													className="newsItem__img m-0 image"
													item={item}
													alt={item.image_caption ? item.image_caption : ''}
													sizes='(max-width: 991px) 100vw, 50vw'
												/>
											) : (
												<img
													src={defaultImage} 
													className="w-100 h-auto"
													width="212" height="44"
													alt=""
													/>
											)}
										</div>
										<span className="newsItem__readmore" aria-hidden="true"><FontAwesomeIcon icon={faChevronRight} /></span>
									</figure>
									<Card.Content >									
										<Card.Header as="h3" className="newsItem__title">
											<UniversalLink href={flattenToAppURL(item['@id'])} className="newsItem__link stretched-link">{item.title}</UniversalLink>
										</Card.Header>
										<Card.Description as="p" className="newsItem__desc">{item.description}</Card.Description>
									</Card.Content>
									<Sharing id={item['@id']} title={item.title} url={flattenToAppURL(item['@id'])} />
								</Card>
							</Grid.Column>
						))}
					</Grid.Row>
				</Grid>

				{link &&
					<p className="readMoreItem d-print-none  mb-4 text-center pt-2">
						<UniversalLink href={link} className="readMoreItem__btn ui primary button ">						
							{linkTitle ? (<span>{linkTitle}</span>) : (
								<>
									<FormattedMessage id="See more" defaultMessage="See more" /> {blockTitle}
								</>
							)} 
						</UniversalLink>
					</p>
				}

			</Container>
		</div>
	);
}

PromosListing.propTypes = {
	linkHref: PropTypes.arrayOf(PropTypes.any),
	items: PropTypes.arrayOf(PropTypes.any).isRequired,
	linkMore: PropTypes.any,
	isEditMode: PropTypes.bool,
};

export default PromosListing;
